import { ProjectDto } from '@app/models/dtos/contentDto';

const BUCKET = 'https://nabinkawan.github.io/bucket/portfolio/images/projects';

const projects: ProjectDto[] = [
    {
        id: 'ai-movie-platform',
        featured: true,
        title: 'AI Movie Generation Platform',
        blurb: 'Script to finished film. LLM-planned shots feed Temporal-orchestrated render pipelines, a browser timeline editor stays responsive at 600–700 shots, and finished movies ship through encrypted streaming with Stripe billing.'
    },
    {
        id: 'govtool',
        featured: true,
        title: 'Sancho GovTool',
        blurb: 'Open-source on-chain governance letting ADA holders vote under CIP-1694. Contributed through Sireto with IntersectMBO.',
        image: '/images/previews/govtool.jpg',
        link: 'https://github.com/IntersectMBO/govtool'
    },
    {
        id: 'bettercollected',
        featured: true,
        title: 'bettercollected',
        blurb: 'A privacy-first form builder for teams that treat a response as the responder’s data.',
        image: `${BUCKET}/bettercollected.png`,
        link: 'https://bettercollected.com/'
    },
    {
        id: 'cardano-test-wallet',
        title: 'Cardano Test Wallet',
        blurb: 'A test wallet that made end-to-end Web3 testing workable. Now used to test GovTool itself.',
        link: 'https://github.com/cardanoapi/cardano-test-wallet'
    },
    {
        id: 'kuber-ide',
        title: 'Kuber IDE',
        blurb: 'A ready-made environment for writing Plutus contracts and Cardano transactions, without the local toolchain fight.',
        image: `${BUCKET}/kuber-ide.png`,
        link: 'https://kuberide.com/'
    },
    {
        id: 'tikeet',
        title: 'Tikeet',
        image: `${BUCKET}/tikeet.png`,
        // tikeet.io resolves but its server no longer responds — restore the link if it comes back.
        blurb: 'Payment-linked access for commissioned digital work. The file unlocks only once payment clears.'
    },
    {
        id: 'iou',
        title: 'IOU',
        image: `${BUCKET}/iou.png`,
        // The Play Store listing now 404s — the app appears to be delisted.
        blurb: 'Finds circular debt chains between people and collapses them, so three IOUs settle as one transaction.'
    }
];

export default projects;
